import { type TFunction } from "i18next";
import { type FieldValues } from "react-hook-form";
import { type ValidationOptions } from "@/components/common/formElements/types";
import { isDateValid } from "@/components/common/formElements/utils/dates";

export function applyDateValidationOptions<TFieldValues extends FieldValues>(
  t: TFunction,
  rules: ValidationOptions<TFieldValues> = {},
) {
  rules.validate = {
    validateDate: (date) => {
      if (!!date && !isDateValid(date)) {
        return t("validation.error.code.INVALID_DATE");
      }
    },

    ...rules.validate,
  };

  return rules;
}
